import { number } from "yup";


function formData(payload) {
  const data = new FormData();
  Object.keys(payload).forEach((key) => data.append(key, payload[key]));
  return data;
}

export function createSignupClientFormData(client) {
  
  const payload = { ...client };
  return formData(payload);
}

export function createSignupAdminFormData(admin) {
  

  const payload = { ...admin };

  return formData(payload);
}

export function createSignupEntrepreneurFormData(entrepreneur) {
 
  const payload = { ...entrepreneur};

  return formData(payload);
}

export function createLoginFormData(loginData) {
  const identifier = loginData.email;
  const payload = { ...loginData, email: identifier };

  return formData(payload);
}

export function createUpdateEntrepreneurFormData(updateData) {

  const payload = { ...updateData };

  return formData(payload);
}

export function createProductFormData(productData) {
  const formData = new FormData();
  
  // Anexando outros campos ao FormData
  Object.keys(productData).forEach(key => {
    if (key !== 'tags' && productData[key] !== undefined) { // Ignora 'tags' neste loop
      formData.append(key, productData[key]);
    }
  });

  // Tratamento especial para 'tags' que é um array de objetos { id, name }
  if (productData.tags && productData.tags.length > 0) {
    productData.tags.forEach(tag => {
      formData.append('tags[]', tag.id); // Anexa apenas o ID de cada tag
    });
  }

  return formData;
}


export function UpdateProductData(productData){
 
  
  const payload = {
    ...productData,
 
    category_id: Number(productData.category_id),
   
    top_news: Number(productData.top_news),
 
  };

  

  return payload;
}

export function createGiftVoucherFormData(giftVoucherData) {

  const payload = {
    ...giftVoucherData,
    name: String(giftVoucherData.name),
    price: Number(giftVoucherData.price),
    description: String(giftVoucherData.description),

    amount: Number(giftVoucherData.amount),
    category_id: Number(giftVoucherData.category_id),
  };
  return formData(payload);
}
